import LoanProductPage from '@/pages/loan/components/LoanProductPage';

export default function SelfEmployedPage() {
  return <LoanProductPage slug="self-employed" />;
}